import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize, Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { AlertService } from '../components/alert/alert.service';
import { Router } from '@angular/router';
import { NiasAuthRoute } from '../constants/routes.constant';
import { AuthService } from '../services/auth.service';

export function notificationInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const alertSevice: AlertService = inject(AlertService);
  const loaderService: LoaderService = inject(LoaderService);
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);

  loaderService.show();
  loaderService.addRequest();

  return next(req).pipe(
    catchError((httpErrorResponse: HttpErrorResponse) => {
      if(httpErrorResponse.status === 401 || httpErrorResponse.status === 403) {
          authService.logout();
          router.navigateByUrl(NiasAuthRoute);
      }else {
          if(httpErrorResponse.error.Message){
            alertSevice.open('error', httpErrorResponse.error.Message);
          }else {
            alertSevice.open('error', 'ERRORS.GLOBAL-ERROR')
          }
      }

      throw httpErrorResponse;
    }),
    finalize(() => {
      loaderService.hide();
      loaderService.removeRequest();
    })
  );
}
